import React from "react";
import isEmpty from "lodash/isEmpty";
import { Button } from "react-bootstrap";
import { Delete } from "@material-ui/icons";
import Accordion from "./Accordion";
import SelectDropdown from "./SelectDropdown";

const ClipAnimation = ({
  getClipNames,
  updateConfig,
  playAnimation,
  ...rest
}) => {
  return (
    <div className="clipAnimationContainer">
      <Accordion
        className="clip-animation-accordion"
        panelList={[
          {
            header: "Clip Animation",
            headerClass: "clip-animation-accordion-header",
            component: (
              <div className="componentContainer">
                {!isEmpty(rest?.currentConfig) && (
                  <div className="selectedAnimation">
                    <div className="animationInfo">
                      <div className="animationDetail">
                        {rest.currentConfig.clipName}
                      </div>
                      <div className="actions">
                        <Button
                          variant="secondary"
                          onClick={() => updateConfig(null)}
                        >
                          <Delete fontSize="small" />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                <SelectDropdown
                  menuList={getClipNames()}
                  onMenuSelect={(animationValue) => {
                    playAnimation(animationValue);
                    console.log("updateinside clip", animationValue);
                    updateConfig({
                      clipName: animationValue,
                      startFrame: 0,
                      endFrame: 0,
                    });
                  }}
                  placeholder="Select Animation"
                />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default ClipAnimation;
